import { Trans, useTranslation } from 'react-i18next'
import { tmsApi } from '#api/tmsApi'
import { Button } from '#components/Button'
import { Icon } from '#components/Icon'
import { resetSessionState, signInRedirect } from '#features/User/userManager'
import ForbiddenIcon from '#icons/lock-48.svg'
import { useSharedAppDispatch } from '#store/sharedBaseStore'
import { largeIconPageClass } from './style'

export const ForbiddenPage = () => {
  const { t } = useTranslation('shared')
  const dispatch = useSharedAppDispatch()
  const hasBack = window.history.length > 2

  return (
    <div className={largeIconPageClass}>
      <Icon className="_icon" iconUrl={ForbiddenIcon} size="xxl" />
      <h1 className="_subtitle">{t('user.forbidden.title', 'You do not have permission to access this page.')}</h1>
      <p className="_message">
        <Trans i18nKey="user.forbidden.message" ns="shared">
          If you believe this is an error, please contact your administrator or request access through the appropriate channels.
          <br />
          You can find more information in the <a href="https://confluence.collaboration-man.com/display/MANC4TMS">Confluence Pages</a>.
        </Trans>
      </p>
      <section>
        <Button
          kind="secondary"
          onClick={async () => {
            resetSessionState()
            dispatch(tmsApi.util.resetApiState())
            await signInRedirect()
          }}
        >
          {t('user.forbidden.sign-in', 'Sign in again')}
        </Button>

        {hasBack && (
          <Button
            onClick={() => {
              window.history.go(-2)
            }}
          >
            {t('common.button.back')}
          </Button>
        )}
      </section>
    </div>
  )
}
